import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";

import css from './OrdersSingleAvailableDishModal.module.css';
import {ordersActions} from "../../../../store/slices/orders-slices";
import {ordersService} from "../../../../services/orders-services";
import {ImageReusable} from "../../../../ui";


const OrdersSingleAvailableDishModal = ({dish: dishG, setIsShowUpdateSingleDish, dataOfDay, setObj}) => {
    const dispatch = useDispatch();
    const {dishId, dish: {name, weight, energy, img}} = dishG;
    const {idPackForBack, idPackMealForBack, idMatching} = useSelector(store => store.sampleMenu);
    const {trigger, selectedDatesArray} = useSelector((store) => store.orders);

    const {t, i18n} = useTranslation();
    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name['en'];

    // Debug logging to check data structure
    console.log('OrdersSingleAvailableDishModal - dishG:', dishG);
    console.log('OrdersSingleAvailableDishModal - img:', img);
    console.log('OrdersSingleAvailableDishModal - dish.img:', dishG.dish.img);


    // Fetching menu dishes for selected dates
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await ordersService.getAllMenuDishesForDate(selectedDatesArray);
                dispatch(ordersActions.changeMenuDishesPacksForDates(res.data));
            } catch (error) {
                console.error(t('modal-toast-fetch-error'), error);
                toast.error(t('modal-toast-fetch-error'));
            }
        };

        fetchData();
    }, [trigger, selectedDatesArray, dispatch]);


    // Handle the click to update the dish
    const handleClick = (e) => {
        e.preventDefault();
        try {
            if (idMatching) {
                setObj(prev => {
                    return prev.map((pack) => {
                        if (!pack.menuDishes) return pack;

                        return {
                            ...pack,
                            menuDishes: pack.menuDishes.map(md => {
                                if (
                                    md.mealId === idPackMealForBack &&
                                    md.packId === idPackForBack
                                ) {
                                    return {
                                        ...md,
                                        dishId: dishId,
                                        dish: dishG.dish
                                    };
                                }
                                return md;
                            })
                        };
                    });
                });
            }
            setIsShowUpdateSingleDish(false);
            toast.success('Successfully updated');
        } catch (error) {
            console.error(t('modal-toast-creating-error'), error);
            toast.error(t('modal-toast-creating-error'));
        }
    };


    return (
        <div className={css.wrap} onClick={handleClick}>
            <div className={css.imgBlock}>
                <ImageReusable src={img} alt="Food Image"/>
            </div>

            <div className={css.name}>
                {displayName}
            </div>

            <div className={css.info}>
                {weight} g/ {energy} kcal
            </div>
        </div>
    );
};

export {OrdersSingleAvailableDishModal};
